<template>
  <div class="wrap vertical-spacing min-h-100">
    <SfHeading
      :level="1"
      :title="title"
    />
    <Loader
      :loading="isLoading"
      :text="$t('Loading products...')"
    >
      <div class="filter-bar container-fluid">
        <div class="row">
          <div class="col-xs">
            <SfCheckbox
              :disabled="deisabledRetrofit"
              v-model="retrofit"
              :label="$t('Show retrofit')"
            />
          </div>
        </div>
      </div>
      <ProductList :products="filterBoards()">
        <template v-slot="{ product }">
          <ProductListItem :product="product" productUrl="Level4Product" />
        </template>
      </ProductList>
    </Loader>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { Loader } from '@/modules/core';
import { SfHeading, SfCheckbox } from '@storefront-ui/vue';
import breadcrumbs from '@/modules/core/mixins/breadcrumbs';
import ProductList from '../components/product/ProductList.vue';
import ProductListItem from '../components/product/ProductListItem.vue';

export default {
  name: 'Level4Category',
  mixins: [breadcrumbs],
  components: {
    SfHeading,
    SfCheckbox,
    Loader,
    ProductList,
    ProductListItem,
  },
  data() {
    return {
      isLoading: true,
      retrofit: false,
      products: this.boards,
    };
  },
  created() {
    const { category } = this.$route.params;
    this.routeBreadcrumbs(this.categoriesPath);
    this.fetchCategory(category)
      .then((data) => {
        const payload = Object.assign(this.filters, {
          id: category,
          searchType: parseInt(data.ParentCategoryId, 10)
            ? 'GroupedSubCat'
            : 'Grouped',
        });
        return this.fetchBoards(payload);
      })
      .then(() => {
        this.isLoading = false;
      });
  },
  computed: {
    deisabledRetrofit() {
      return this.boards.every((item) => !item.Retrofit);
    },
    title() {
      return this.$route.params.name;
    },
    ...mapGetters({
      categoriesPath: 'level4/categoriesPath',
      boards: 'level4/boards',
      filters: 'level4/filters',
    }),
  },
  methods: {
    filterBoards() {
      return this.retrofit
        ? this.boards
        : this.boards.filter((product) => !product.Retrofit);
    },
    ...mapActions({
      fetchBoards: 'level4/fetchBoards',
      fetchCategory: 'catalog/fetchCategory',
    }),
  },
};
</script>
